import { Box, Typography } from "@mui/material";
import { HeaderStyle } from "../Common/styles/header";
import ParticipantList from "./ParticipantsList";
import { useEffect, useState } from "react";
import {
  a11yProps,
  CustomTabPanel,
  CustomTabPanel2,
  StyledTab,
  StyledTabs,
} from "../Common/UI/TabPanel";
import ParticipantDuplicates from "./Duplicates/ParticipantDuplicates";
import PlatformDashboardContent from "./PlatformDashboard/PlatformDashboardContent";
import { useSearchParams } from "react-router-dom";
import CohortBuilder from "./nested-builder/CohortBuilder";
import { scrollableTabPageContent } from "../../utils/dataTableShell";

const Participants = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedTab, setSelectedTab] = useState(
    searchParams.get("type") || "dashboard"
  );

  useEffect(() => {
    const params = new URLSearchParams();

    if (selectedTab) {
      params.set("type", selectedTab);
    }

    setSearchParams(params, {
      replace: true,
    });
  }, [setSearchParams, selectedTab]);

  // const hasFilter = useMemo(() => {
  //   return Object.values(filters).some((value) => value !== "");
  // }, [filters]);

  const handleTabsChange = (_: any, newValue: string) => {
    setSelectedTab(newValue);
  };

  return (
    <>
      <Box sx={HeaderStyle}>
        <Typography variant="h2" color="text.primary">
          Participants
        </Typography>
        {selectedTab === "participants_list" && (
          <Box
            sx={{
              marginLeft: "auto",
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            {/* {hasFilter && (
              <Button variant="outlined" component="label">
                Send to Study
              </Button>
            )} */}
          </Box>
        )}
      </Box>
      <Box sx={{ borderBottom: 1, borderColor: "#E5E7EB" }}>
        <StyledTabs value={selectedTab} onChange={handleTabsChange}>
          <StyledTab label="Dashboard" value="dashboard" {...a11yProps(0)} />
          <StyledTab
            label="All Participants"
            value="participants_list"
            {...a11yProps(1)}
          />
          <StyledTab
            label="Duplicates Tracker"
            value="duplicates_tracker"
            {...a11yProps(2)}
          />
          <StyledTab
            label="Criteria Filter"
            value="cohort_filter"
            {...a11yProps(3)}
          />
        </StyledTabs>
      </Box>
      <Box sx={scrollableTabPageContent("calc(100% - 122px)")}>
        <CustomTabPanel value={selectedTab} index={"dashboard"}>
          <PlatformDashboardContent />
        </CustomTabPanel>
        <CustomTabPanel2 value={selectedTab} index={"participants_list"}>
          <ParticipantList />
        </CustomTabPanel2>
        <CustomTabPanel2 value={selectedTab} index={"duplicates_tracker"}>
          <ParticipantDuplicates />
        </CustomTabPanel2>
        <CustomTabPanel value={selectedTab} index={"cohort_filter"}>
          <CohortBuilder />
        </CustomTabPanel>
      </Box>
    </>
  );
};

export default Participants;
